export default "__VITE_ASSET__3f794644__"